module.exports = __webpack_public_path__ + "img/Download.b933fc2a.webp";